import React, { useEffect, useState } from 'react'
import useHistorical from '../../hooks/useHistorical'
import Spinner from 'react-bootstrap/Spinner';
import Button from '../../components/Button/Button';
import ConnectButton from '../../components/ConnectButton/ConnectButton';

//import { Historical } from '../../types/Historical';
import { useWeb3Context } from '../../hooks/useWeb3Context';
import { onChainProvider } from '../../types/onChainProvider';
import { checkAddressOnWhitelist, getHistoricalNftsForWallet, signUpForWhitelist } from '../../helpers/calls';
import { useLocation } from 'react-router-dom';
import { IWhitelist } from '../../types/IWhitelist';
import Modal from 'react-bootstrap/Modal';

interface Props { }

const Home: React.FC<Props> = (props) => {
    const { address, disconnect }: onChainProvider = useWeb3Context();
    const [addressOnWhitelist, setAddressOnWhitelist] = useState(false);

    const [isChecking, setIsChecking] = useState(false);
    const [addressChecked, setAddressesChecked] = useState(false);
    const [checkingDone, setCheckingDone] = useState(false);
    const [enteringEmail, setEnteringEmail] = useState(false);

    const [loadingTitle, setLoadingTitle] = useState("");
    const [loadingMsg, setLoadingMsg] = useState("");
    const [email, setEmail] = useState("");

    const { historicalNfts, getNftByTokenParam, total } = useHistorical();
    const [historicalNftsAddress, setHistoricalNftsAddress] = useState<any>([]);
    const [busySigning, setBusySigning] = useState(false);
    const [signupSuccess, setSignupSuccess] = useState(false);
    const [readMoreOpen, setReadMoreOpen] = useState(false);
    const [openWalletInfo, setOpenWalletInfo] = useState(false);
    const { hash } = useLocation();

    const buttonPlayGame = () => {
        window.open('https://fartgame.kaijulegends.io', '_blank');
    }

    const buttonCheckWallet = async () => {
        setIsChecking(true);
        setLoadingTitle("Whitelist");
        setLoadingMsg("Checking whitelist, please wait...");

        const alreadySigned = await checkAddress();
        if (alreadySigned) {
            setAddressOnWhitelist(true);
        }
        setTimeout(() => {
            setAddressesChecked(true);
            setCheckingDone(true);
        }, 1000);
    }

    const buttonGoToEmail = () => {
        setEnteringEmail(true);
    }

    const buttonContinue = async () => {
        setIsChecking(true);
        setLoadingTitle(!hash ? "Checking NFT's" : `Checking ${getNftByTokenParam(historicalNfts).token} ${showTokenOrNftText()}`);
        setLoadingMsg(!hash ? "Checking eligible NFT's, this may take a few minutes..." : `Checking ${getNftByTokenParam(historicalNfts).token} in your wallet`);
        // check
        await checkHistoricalsForWallet();

        setTimeout(async () => {
            setLoadingTitle("Whitelist");
            setLoadingMsg("Checking sign ups, please wait...");
            const alreadySigned = await checkAddress();
            if (alreadySigned) {
                setAddressOnWhitelist(true);
            }
            setTimeout(() => {
                setCheckingDone(true);
            }, 1000);
        }, 1000);
    }

    const buttonSignUpForWhitelist = async () => {
        // set busy to show loader
        setBusySigning(true);
        setEnteringEmail(false);

        // artificial timer for loader
        setTimeout(async () => {
            const alreadySigned = await checkAddress();
            if (alreadySigned) {
                setAddressOnWhitelist(true);
                setBusySigning(false);
            } else {
                const whitelister: IWhitelist = {
                    gamePassCode: '',
                    discord: '',
                    wallet: address,
                    email: email,
                    origin: hash ? hash.replace('#', '') : 'Website'
                }
                const signup = await signUpForWhitelist(whitelister);
                if (signup) {
                    if (signup.success) {
                        // signup was a success
                        setSignupSuccess(true);
                    } else {
                        // error signing up for the whitelist
                        setSignupSuccess(false);
                    }
                }

                // remove loading
                setBusySigning(false);
            }
        }, 1500);
    }

    const checkAddress = async (): Promise<boolean> => {
        const onWhitelist: boolean = await checkAddressOnWhitelist(address);
        return onWhitelist
    };

    const checkHistoricalsForWallet = async (): Promise<boolean> => {
        const historicals: any = await getHistoricalNftsForWallet(address, hash ? hash : '');

        setHistoricalNftsAddress(historicals);

        return true;
    }

    const showTokenOrNftText = () => {
        if (getNftByTokenParam(historicalNfts) && getNftByTokenParam(historicalNfts).token !== null) {
            if (!getNftByTokenParam(historicalNfts).isNFT) {
                return 'Token'
            } else {
                return 'NFT'
            }
        }

        return 'NFT'
    }

    useEffect(() => { }, [hash])

    const renderSocialButtons = () => {
        return <React.Fragment>
            <Button className="button l-btn social-btn discord-button" onClick={() => { window.open("https://discord.gg/kaijulegendsnft", "_blank") }}>
                <i className="fa-brands fa-discord"></i>
                <span>Join Discord</span>
            </Button>
            <Button className="button l-btn social-btn twitter-button" onClick={() => { window.open("https://twitter.com/intent/follow?screen_name=KaijuLegendsNFT", "_blank") }}>
                <i className="fa-brands fa-twitter"></i>
                <span>Follow us</span>
            </Button>
            <Button className="button l-btn social-btn instagram-button" onClick={() => { window.open("https://www.instagram.com/kaijulegendsnft", "_blank") }}>
                <i className="fa-brands fa-instagram"></i>
                <span>Instagram</span>
            </Button>
        </React.Fragment>
    }

    const renderContent = () => {
        // check if we are connected
        if (address && isChecking) {
            if (!checkingDone) {
                return <React.Fragment>
                    <div className="banner-loader">
                        <div className="banner-loader-icon">
                            <Spinner animation="border" role="status"></Spinner>
                        </div>
                        <h3>{loadingTitle}</h3>
                        <p>{loadingMsg}</p>
                    </div>
                </React.Fragment>
            }

            // check if we are already on the whitelist
            if (addressOnWhitelist && checkingDone) {
                return <React.Fragment>
                    <div className="banner-sub-main">
                        <h3>ALREADY WHITELISTED</h3>
                        <p>The address below is already whitelisted. Be sure to follow up on all social channels for the latest updates on release dates, airdrops and more!</p>
                    </div>
                    <div className="banner-address">{address}</div>
                    <div className="banner-sub-buttons">
                        {renderSocialButtons()}
                    </div>
                </React.Fragment>
            } else {
                if (addressChecked) {
                    return <React.Fragment>
                        <div className="banner-sub-main">
                            <h3>NOT WHITELISTED YET</h3>
                            <p>The current address is not yet whitelisted.</p>
                        </div>
                        <div className="banner-address">{address}</div>
                        <div className="banner-sub-buttons sub-buttons-right sub-buttons-single">
                            <Button onClick={() => window.location.reload()} disabled={!address} className='button l-btn'>
                                Go back
                            </Button>
                        </div>
                    </React.Fragment>
                } else if (busySigning) {
                    // check if we are signing up, have signed up or need to sign up
                    // show loading
                    return <React.Fragment>
                        <div className="banner-loader">
                            <div className="banner-loader-icon">
                                <Spinner animation="border" role="status"></Spinner>
                            </div>
                            <h3>Signing up</h3>
                            <p>Finalizing, please wait...</p>
                        </div>
                    </React.Fragment>
                } else if (signupSuccess) {

                    // show success page
                    return <React.Fragment>
                        <div className="banner-success">
                            <div className="banner-success-icon">
                                <div className="success-icon"><i className="fa-light fa-check"></i></div>
                            </div>
                            <div className="banner-sub-main">
                                <h3>CONGRATULATIONS!</h3>
                                <p>You have successfully signed up for the Kaiju Legends Whitelist. Be sure to follow up on all social channels for the latest updates on release dates, airdrops and more!</p>
                            </div>
                            <div className="banner-sub-buttons">
                                {renderSocialButtons()}
                            </div>
                        </div>
                    </React.Fragment>

                } else if (enteringEmail) {
                    return <React.Fragment>
                        <div className="banner-sub-main">
                            <h3>Finalize Sign-up</h3>
                            <p>In order to complete your sign-up, please leave your e-mail address. This way we can keep you updated on the launch date and time, upcoming airdrops and other news. Be aware: we will NEVER send minting links or spam in the e-mail.</p>
                        </div>

                        <input
                            aria-label="email" aria-required="true" type="email" onChange={(event) => setEmail(event.target.value)}
                            className="form-control" data-inputmask="" name="fields[email]" placeholder="Email" autoComplete="email"></input>
                        <div className="banner-sub-buttons sub-buttons-large">
                            <Button onClick={() => buttonSignUpForWhitelist()} disabled={!address || email.length < 1} className='button'>
                                Finalize whitelisting
                            </Button>
                        </div>
                    </React.Fragment>

                } else {
                    return <React.Fragment>
                        <div className="banner-sub-main">
                            <h3> {total >= 1 ? `${showTokenOrNftText()} found!` : 'Oh no!'}</h3>
                            {
                                !hash || !getNftByTokenParam(historicalNfts).token ?
                                    <p>In order to participate in the whitelist you need to have one of the following tokens in your wallet. More to be announced soon!<br></br><br></br>Your total amount: {total}</p>
                                    :
                                    <p>In order to participate in the whitelist you need to have a {historicalNftsAddress[0].token} {showTokenOrNftText()} in your wallet.<br></br><br></br>Your total amount: {total}</p>
                            }
                        </div>

                        <div className="banner-address">{address}</div>
                        <div className="banner-sub-buttons sub-buttons-right sub-buttons-single">
                            {/* <Button className="button l-btn social-btn" onClick={()=> { window.location.href = "https://www.discord.com/"}} style={{ marginTop: 48 }}>    
                            <i className="fa-brands fa-discord"></i>
                            <span></span>
                        </Button> */}
                            <Button onClick={() => buttonGoToEmail()} disabled={!address || total <= 0} className='button'>
                                Sign up
                            </Button>
                        </div>
                    </React.Fragment>
                }
            }
        } else {
            return <React.Fragment>
                <div className="banner-sub-main">
                    <div className="banner-sub-title">
                        <h3>JOIN WHITELIST</h3>
                    </div>
                    <div className="banner-block-inline">
                        <div className="banner-block-inline-text">
                            <span>Method 1</span>
                            <p> Play the game! The fastest way to join the whitelist is to play the game and reach a score of at least 25. Sounds easy right? </p>
                        </div>
                        <div className="banner-block-inline-btn">
                            <Button onClick={() => buttonPlayGame()} className='button'>
                                <i className="fa-light fa-gamepad-modern"></i>
                                <span>Play now</span>
                            </Button>
                        </div>
                    </div>
                    <div className={`banner-block-inline ${readMoreOpen ? 'open' : ''}`}>
                        <div className="banner-block-inline-text">
                            <span>Method 2</span>
                            {
                                !hash || !getNftByTokenParam(historicalNfts).token ?
                                    <React.Fragment>
                                        <p>In order to participate in the whitelist you need to have one of the following tokens in your wallet. More to be announced soon!</p>
                                        {
                                            historicalNfts && historicalNfts.length > 0 ?
                                                <div className="txt-btn" onClick={() => setReadMoreOpen(!readMoreOpen)}>
                                                    <span>Show eligible NFT's / Tokens</span>
                                                    <i className="fa-light fa-angle-down"></i>
                                                </div>
                                                :
                                                <></>
                                        }

                                    </React.Fragment>
                                    :
                                    <p>In order to participate in the whitelist you need to have a <b>{getNftByTokenParam(historicalNfts).token} {showTokenOrNftText()}</b> in your wallet </p>
                            }

                            <div className="banner-text-collapse">
                                <ul>
                                    {
                                        (!hash || !getNftByTokenParam(historicalNfts).token) && historicalNfts.map((nft) => {
                                            return <li key={nft.token}>
                                                <a href={nft.opensea} target="_blank" rel="noreferrer">
                                                    {nft.token}
                                                </a>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="banner-block-inline-btn">
                            {!address
                                ? <ConnectButton onClick={() => { }} />
                                : <Button className='button' onClick={() => buttonContinue()}>
                                    <i className="fa-light fa-angle-right"></i>
                                    <span>Check now</span>
                                </Button>
                            }
                        </div>

                    </div>
                    <div className={`banner-block-inline`}>
                        <div className="banner-block-inline-text">
                            <span>Check whitelist</span>
                            <p>Would you like to know if you're already on the list?<br></br>Check it here!</p>
                        </div>
                        <div className="banner-block-inline-btn">
                            {
                                !address ?
                                    <ConnectButton onClick={() => { }} />
                                    :
                                    <Button onClick={() => buttonCheckWallet()} className='button'>
                                        <i className="fa-light fa-angle-right"></i>
                                        <span>Check now</span>
                                    </Button>
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>

        }
    }

    return (
        <div id="outer-wrapper">
            <div id="main-wrapper">
                <div id="bg-wrapper"></div>
                <Modal className='wallet-info-modal' show={openWalletInfo} onHide={() => setOpenWalletInfo(!openWalletInfo)}>
                    <Modal.Body className='no-pad'>
                        <div className="banner-sub-block ">
                            <div className="banner-sub-main">
                                <h3>WALLET INFORMATION</h3>
                            </div>
                            <div className="banner-address">{address}</div>
                            <div className="banner-sub-buttons sub-buttons-right sub-buttons-single">
                                <Button className="button" onClick={() => disconnect()}>
                                    <span>Disconnect</span>
                                </Button>
                                <Button className="button l-btn" onClick={() => setOpenWalletInfo(!openWalletInfo)}>
                                    <span>Close</span>
                                </Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <div id="content-wrapper">
                    <div id="banner-wrapper-sub">
                        <div className="header-sub">
                            <div className="header-logo-sub">
                                <a href="/">
                                    <img src=" ../images/kaiju-logo.svg" alt="Kaiju Legends" />
                                </a>
                            </div>
                            <div className="sticky-button-sub">
                                <a href="https://www.kaijulegends.io" className="button l-btn">
                                    <i className="fa-light fa-angle-left"></i>
                                    <span>Back to website</span>
                                </a>
                                <ConnectButton onClick={() => setOpenWalletInfo(!openWalletInfo)} />
                            </div>
                        </div>
                        <div className="container">
                            <div id="banner-sub">
                                <div className={`banner-sub-image ${busySigning || signupSuccess || (!checkingDone && isChecking) ? 'banner-loading' : ''}`}>
                                    <img src="../images/kaiju-top-pop-up.png" alt="Kaiju Legends" />
                                </div>
                                <div className={`banner-sub-block ${busySigning ? 'banner-loading' : ''}`}>
                                    {
                                        renderContent()
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)

    // <div id="main-wrapper">
    //     <div id="bg-wrapper"></div>
    //     <Menu />
    //     <div className="block-wrapper">
    //         <div className="container">
    //             <h4>Historical list</h4>
    //             {/* {historicalNfts && historicalNfts.length > 0 && !historicalNftsIsLoading
    //                 ?
    //                 historicalNfts.map((nft: Historical) => {
    //                     return <div>
    //                         <div>Token: {nft.token}</div>
    //                         <div>Balance: {!address ? 0 : balanceIsLoading ? 'Loading...' : nft.balance}</div>
    //                     </div>
    //                 })
    //                 : historicalNftsIsLoading
    //                     ? <div>
    //                         <Spinner animation="border" role="status"></Spinner>
    //                     </div>
    //                     : <></>
    //             } */}

    //             {!address
    //                 ? <ConnectButton style={{ marginTop: 48 }} />
    //                 : <Button onClick={()=>buttonSignUpForWhitelist()} disabled={!address} className='button' style={{ marginTop: 48 }}>
    //                     Sign up for the whitelist
    //                 </Button>
    //             }
    //         </div>
    //     </div>
    // </div>)
}

export default Home
